import {
  Backdrop,
  CircularProgress,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import {
  GetUserBranchesResponse,
  LoginRequest,
  Role,
  RoleApi,
  UserApi,
  ValidateCredsResponseBranches,
} from "../../../api/auth";
import { BASE_PATH } from "../../../environment";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loginInfo, branchRoles, configState, loggedEmployee } from "../../../recoil/atoms";
import { Employee, EmployeeApi } from "../../../api/clinic-management";
import { IconBuilding } from "@tabler/icons";
import { toast } from "react-toastify";

const SwitchBranch = () => {
  const config = useRecoilValue(configState);
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);

  const setRoles = useSetRecoilState<Role[]>(branchRoles);
  const [employee, setEmployee] = useRecoilState<Employee>(loggedEmployee);
  const [branches, setBranches] = useState<GetUserBranchesResponse>();
  const setAccessTokenGlobal = useSetRecoilState(configState);
  const setLoggedInBranch = useSetRecoilState<ValidateCredsResponseBranches>(loginInfo);

  const loginBranch = (values: LoginRequest) => {
    const user = new UserApi(config);
    user
      .login(values)
      .then((res) => {
        setLoading(false);
        localStorage.setItem("AccessToken", res.data.AccessToken!);
        setAccessTokenGlobal({ ...configState, apiKey: res.data.AccessToken! });
        navigate("/");
        setLoggedInBranch(res?.data);
        localStorage.setItem("LoginInfo", JSON.stringify(res?.data));
        getRoles(res?.data?.AccessToken!);
        getEmployee(res?.data?.AccessToken!, res.data.EmployeeID!);
        toast.success("Switched to Branch Successfully");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const submitLogin = (values: LoginRequest) => {
    loginBranch(values);
  };

  const getRoles = (apiKey: string) => {
    const role = new RoleApi({ basePath: BASE_PATH, apiKey: apiKey });
    role
      .getAllRoles()
      .then((res) => {
        setRoles(res.data);
        localStorage.setItem("BranchRoles", JSON.stringify(res.data));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const getBranches = () => {
    const user = new UserApi(config);
    user
      .getUserBranches()
      .then((res) => {
        setBranches(res.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const getEmployee = (apiKey: string, employeeID: string) => {
    const employee = new EmployeeApi({ basePath: BASE_PATH, apiKey: apiKey });
    employee
      .getTenantEmployeeById(employeeID)
      .then((res) => {
        localStorage.setItem("LoggedEmployee", JSON.stringify(res.data));
        setEmployee(res.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getBranches(), []);

  return (
    <>
      <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ p: 1 }}>
        <List
          component="nav"
          sx={{
            width: "100%",
            maxWidth: 350,
            minWidth: 300,
            backgroundColor: "#ffff",
            borderRadius: "10px",
            marginTop: 1,
            padding: 2,
          }}
        >
          {branches?.Branches?.map((branch: ValidateCredsResponseBranches) => {
            return (
              <ListItemButton
                sx={{
                  borderRadius: "16px",
                  bgcolor: "#FFE8F8",
                }}
                disabled={branch?.BranchID === employee?.BranchID ? true : false}
                onClick={() => {
                  setLoading(true);
                  submitLogin({
                    BranchID: branch.BranchID!,
                    TenantID: branch.TenantID!,
                  });
                }}
              >
                <ListItemIcon>
                  <IconBuilding stroke={1.5} size="1.3rem" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Grid container spacing={1} justifyContent="space-between">
                      <Grid item>
                        <Typography variant="body2"> {branch.Name}</Typography>
                      </Grid>
                    </Grid>
                  }
                />
                <Backdrop
                  sx={{ color: "#ffff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={loading}
                  onClick={() => setLoading(false)}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              </ListItemButton>
            );
          })}
        </List>
      </Grid>
    </>
  );
};

export default SwitchBranch;
